import VehicleRouteList from "components/VehicleRoute/VehicleRouteList";

export default function VehicleRoutes() {

    return (
        <>
            <section className="without-header-page-body">
                <h2 className="page-title fixed">Routes</h2>
                <VehicleRouteList />
            </section>
        </>
    );
}